import { useThemeStore } from "@stores/theme.store";
import { Button, Select } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { linkPage } from "@utils/router";
import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { Spiner } from "@components/loaders/spiner";
import { FcFinePrint } from "react-icons/fc";
import { StudentHealth } from "@services/dtos/school.dto";
import { PopupCustom } from "@components/general/popup";
import { FilterOutlined } from "@ant-design/icons";
// moment.locale("id");
export const HealthDataPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [limit, setLimit] = useState<string>("10");
  const [popupFilter, setPopupFilter] = useState<boolean>(false);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_HEALTH, nis, limit],
    queryFn: () => SchoolService.studentHealth({ nis, limit }),
  });

  const onOpenDetail = (health: StudentHealth) => {
    navigate(linkPage.HEALTH_DETAIL_PAGE, { state: health });
  };

  useEffect(() => {
    setAppBar({ title: "Kesehatan", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Kesehatan",
      image: false,
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <>
          {/* set filter */}
          <div className="tw-pt-0 tw-text-background-100">
            <div className="tw-flex tw-justify-between tw-items-center">
              <div className="tw-w-2/3 pocket-highlight">
                <div className="tw-text-base tw-text-background-100">
                  Data yang ditampilkan{" "}
                  <span className="tw-font-bold">{limit} data terakhir</span>
                </div>
              </div>
              <div className="pocket-filter">
                <FilterOutlined
                  className="tw-p-2 tw-text-xl tw-bg-transparent card-body"
                  onClick={() => setPopupFilter(true)}
                />
              </div>
            </div>
          </div>
          {/* end of set filter */}

          {/* report */}
          <div className="tw-mt-8">
            {isPending ? (
              <div className="tw-text-center card-body">
                <Spiner />
              </div>
            ) : data?.data != null && data.data.length > 0 ? (
              <div>
                {data.data.map((item, idx) => (
                  <div
                    key={idx}
                    className="tw-mb-4 tw-py-2 card-body"
                    onClick={() => onOpenDetail(item)}
                  >
                    <div className="tw-flex tw-justify-between tw-items-center tw-font-semibold">
                      <div className="tw-text-xs tw-font-medium ">Tanggal</div>
                    </div>
                    <div
                      className="tw-pb-2 tw-mb-2 tw-flex tw-justify-between tw-items-end tw-font-semibold tw-border-primary"
                      style={{ borderBottom: "1px solid" }}
                    >
                      <div className="tw-text-sm">
                        {moment(item.tanggal ?? Date.now()).format(
                          "DD MMMM YYYY"
                        )}
                      </div>
                      <div className="tw-w-1/2 tw-text-end">
                        <div className="tw-text-base">{item.keluhan}</div>
                      </div>
                    </div>

                    <div className="tw-text-xs tw-text-end tw-text-text-tertiary tw-italic">
                      klik untuk melihat detail
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="tw-p-8 tw-text-center card-body">
                <FcFinePrint size={50} />
                <div>Data tidak ditemukan</div>
              </div>
            )}
          </div>
          {/* end of report */}
        </>
      </div>

      <PopupCustom
        title="Filter Data"
        open={popupFilter}
        onCancel={() => setPopupFilter(false)}
        slideUpModal={true}
      >
        <div className="">
          <Select
            className=" tw-text-base"
            placeholder="Pilih Jumlah Ditampilkan"
            defaultValue={limit}
            style={{ width: "100%" }}
            allowClear
            onChange={(e) => setLimit(e)}
            options={[
              { value: "5", label: "5 data terakhir" },
              { value: "10", label: "10 data terakhir" },
              { value: "25", label: "25 data terakhir" },
            ]}
          ></Select>
          <Button
            onClick={() => setPopupFilter(false)}
            className="tw-p-2 tw-mt-6 tw-h-10 tw-w-full tw-text-base tw-rounded-xl tw-bg-red-500 tw-text-background-200 focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-accent-primary hover:tw-border-primary"
          >
            Tutup
          </Button>
        </div>
      </PopupCustom>
    </>
  );
};
